import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import SubCategoryCreate from '../../components/SubCategory/SubCategoryCreate';

const SubCategoryCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <SubCategoryCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default SubCategoryCreatePage;